import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IProductListModel } from '@apps-common/types/management/product'

export const MANAGEMENT_QUERY_KEY_GET_PRODUCTS = (name?: string) => ['getManagementProducts', name].filter(Boolean)

export const getProducts = async (name: string): Promise<IProductListModel[]> =>
  axios.get(`/management/product/getproducts?name=${name}`).then((res) => res.data?.data)

type QueryFnType = typeof getProducts

type Props = {
  config?: QueryConfig<QueryFnType>
  name: string
}

export const useManagementGetProducts = ({ config, name }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_PRODUCTS(name),
    queryFn: () => getProducts(name)
  })
